import { createAction, props } from '@ngrx/store';
import { OpportunityFilters } from '@shared/models/opportunity-filters';

export const setOpportunityFilters = createAction(
  '[Opportunities] Set Opportunity Filters',
  props<{ filters: OpportunityFilters | undefined }>(),
);
